export default __webpack_public_path__ + "b700229d996ac9879d917ff0e1200b37.mp4";